var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.627,298.559a2.922,2.922,0,0,0-2.659-.406l-1.95.65A2.949,2.949,0,0,0,50,301.6V314.4a2.949,2.949,0,0,0,2.018,2.8l1.95.65h0a2.959,2.959,0,0,0,.942.154,2.958,2.958,0,0,0,2.942-2.953v-14.1A2.917,2.917,0,0,0,56.627,298.559Zm-.774,16.489a.952.952,0,0,1-1.252.9L52.65,315.3a.949.949,0,0,1-.65-.9V301.6a.949.949,0,0,1,.65-.9l1.951-.651a.952.952,0,0,1,1.252.9ZM59,300a1,1,0,0,1,1-1h2.968A1.963,1.963,0,0,1,65,300.879V305a1,1,0,0,1-2,0v-3.981L60,301A1,1,0,0,1,59,300Zm6,11v4.121A1.963,1.963,0,0,1,62.968,317H60a1,1,0,0,1,0-2h2.968A.07.07,0,0,1,63,315v-4a1,1,0,0,1,2,0Zm4.707-2.293-2,2a1,1,0,0,1-1.414-1.414l.293-.293H60a1,1,0,0,1,0-2h6.586l-.293-.293a1,1,0,0,1,1.414-1.414l2,2A1,1,0,0,1,69.707,308.707ZM55,306.5v3a.5.5,0,0,1-1,0v-3a.5.5,0,0,1,1,0Z",
    transform: "translate(-48 -296)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.b55b19f2.svg";
export { ForwardRef as ReactComponent };